module.exports = __webpack_public_path__ + "static/media/skull.9b936612.svg";